import React from 'react';

import { graphql, useStaticQuery } from 'gatsby';
import { IGatsbyImageData } from 'gatsby-plugin-image';

import { Section } from '../Section';
import { TestimonialCard } from '../web/cards';
import { Carousel } from '../web/carousel';

type QueryEdgeData = {
  node: {
    sortOrder: number;
    quote: {
      quote: string;
    };
    reviewerPhoto?: {
      gatsbyImageData: IGatsbyImageData;
    };
    reviewerName: string;
    reviewerCompanyPosition: string;
    reviewerPositionInClinic: 'Lab' | 'Operations' | 'Clinic';
  };
};

type QueryData = {
  allContentfulTestimonial: {
    edges: QueryEdgeData[];
  };
};

const Testimonials = () => {
  const data: QueryData = useStaticQuery(graphql`
    {
      allContentfulTestimonial {
        edges {
          node {
            sortOrder
            quote {
              quote
            }
            reviewerName
            reviewerPositionInClinic
            reviewerCompanyPosition
            reviewerPhoto {
              gatsbyImageData(
                width: 60
                height: 60
                quality: 100
                layout: FIXED
              )
            }
          }
        }
      }
    }
  `);

  const cards = data.allContentfulTestimonial.edges
    .sort((a, b) => a.node.sortOrder - b.node.sortOrder)
    .map((e) => (
      // eslint-disable-next-line react/jsx-key
      <TestimonialCard
        type={e.node.reviewerPositionInClinic}
        quote={e.node.quote.quote}
        name={e.node.reviewerName}
        position={e.node.reviewerCompanyPosition}
        img={e.node.reviewerPhoto?.gatsbyImageData}
      />
    ));

  return (
    <Section
      bgClassName={classNames.background}
      className={classNames.container}
    >
      <h3 className={classNames.title}>
        Why IVF clinics like yours choose Alife
      </h3>
      <Carousel elements={cards} />
    </Section>
  );
};

const classNames = {
  background: 'tw-bg-space',
  container: ['tw-overflow-hidden'].join(' '),
  title: ['tw-display3', 'tw-text-white', 'tw-mb-[48px]'].join(' '),
};

export { Testimonials };
